import { render, staticRenderFns } from "./FeatureOverview.vue?vue&type=template&id=b6e30054&"
import script from "./FeatureOverview.vue?vue&type=script&lang=ts&"
export * from "./FeatureOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports